import { ProductSelectionPopulated } from '../models/Cart';
import { environment } from '../../environments/environment';
import { oc } from 'ts-optchain';
import { EntryMethod } from '../models/NewTransaction';

export const needUserInfoForEntry = (entry?: ProductSelectionPopulated) => {
    return !!entry && environment.config.userInfo.length && oc(entry).variant.userData.showForm();
};
